/* aa-offcuts.js - plate offcuts browse page (ASCII only).
   Reads window.AA_OFFCUTS_CFG = { endpoint, products:[{thick,vid,cents,title,url,alloy}] }
   (alloy optional; absent = '5083' so the current 5083-only setup is unchanged)
   (built by the aa-offcuts-page section from the plate products), asks the
   AluCut worker for the live priced offcut list (mode offcut-list), and lets
   the customer add any piece to the cart WHOLE (no cutting charges).
   All pricing + availability rules live server-side; a take re-validates
   against the live snapshot before carting. Cutting from an offcut is done
   in the plate cut tool, not here. */
(function () {
  'use strict';
  var CFG = window.AA_OFFCUTS_CFG || {};
  var EP = CFG.endpoint || 'https://alucut.allaluminium.workers.dev/quote';
  var root = document.getElementById('aa-offcuts-root');
  if (!root) return;

  function money(n) { return '$' + (Number(n) || 0).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function post(body) {
    if (window.AACut && typeof window.AACut.quote === 'function') return window.AACut.quote(EP, body);
    return fetch(EP, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .catch(function () { return { ok: false, errors: ['Network error'] }; });
  }
  function prodAlloy(p) { return String((p && p.alloy) || '5083').trim() || '5083'; }
  /* cut flag: r19 - EVERY product is cut-capable again. Thick products
     (16-100mm) now open the plate cut tool in OFFCUT-ONLY mode (the deep
     link lands on a working tool that cuts from live rack pieces), so the
     r18 cut:false gating is retired. The section still emits cut: flags in
     AA_OFFCUTS_CFG - harmless, deliberately ignored here. */
  function prodCut(p) { return true; }
  /* rates key: plain thickness for 5083 (legacy-compat with the live worker),
     'ALLOY|THICK' for anything else. */
  function rateKey(p) {
    var a = prodAlloy(p);
    return (a === '5083' ? '' : a + '|') + String(p.thick);
  }
  function prodFor(alloy, t) {
    var a = String(alloy || '5083').trim() || '5083';
    var ps = CFG.products || [];
    for (var i = 0; i < ps.length; i++) {
      if (prodAlloy(ps[i]) === a && Number(ps[i].thick) === Number(t)) return ps[i];
    }
    return null;
  }
  function alloyCount() {
    var seen = {}, n = 0, ps = CFG.products || [];
    for (var i = 0; i < ps.length; i++) { var a = prodAlloy(ps[i]); if (!seen[a]) { seen[a] = 1; n++; } }
    return n;
  }
  function agoText(iso) {
    try {
      var mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
      if (mins < 2) return 'updated just now';
      if (mins < 90) return 'updated ' + mins + ' min ago';
      return 'updated ' + Math.round(mins / 60) + ' h ago';
    } catch (e) { return ''; }
  }

  /* r44: deep-link support. The plate collection table links here as
     ?t=<thickness>[&a=<alloy>] so a customer who clicks "N discounted offcuts
     in this thickness" lands on THAT thickness with its accordion open,
     instead of the generic list. All additive - with no ?t= the page behaves
     exactly as before. */
  function deepLinkTarget() {
    try {
      var q = new URLSearchParams(location.search || '');
      var t = q.get('t') || q.get('thick') || '';
      if (!t && /^#t[0-9]/.test(location.hash || '')) t = (location.hash || '').slice(2);
      t = parseFloat(t);
      if (!(t > 0)) return null;
      var al = q.get('a') || q.get('alloy') || '';
      return { thick: t, alloy: al ? String(al) : '' };
    } catch (x) { return null; }
  }
  function accId(alloy, thick) {
    /* Thickness is normalised through parseFloat so 3, "3" and "3.0" all
       produce the same id no matter which side built it. */
    var t = parseFloat(thick);
    return 'oc-' + String(alloy || '').toLowerCase().replace(/[^a-z0-9]+/g, '') +
      '-' + (isFinite(t) ? String(t).replace('.', '_') : 'x');
  }
  function wantsThis(want, alloy, thick) {
    if (!want) return false;
    if (Number(want.thick) !== Number(thick)) return false;
    return !want.alloy || String(want.alloy) === String(alloy);
  }
  function focusThickness(want) {
    try {
      var el = want.alloy
        ? document.getElementById(accId(want.alloy, want.thick))
        : null;
      if (!el) {
        /* Numeric scan - tolerant of "3" vs "3.0" and of an alloy we were
           given that does not match any group on the page. */
        var all = root.querySelectorAll('.aa-oc-acc[data-thick]');
        for (var j = 0; j < all.length; j++) {
          if (Number(all[j].getAttribute('data-thick')) === Number(want.thick)) {
            if (!want.alloy ||
                String(all[j].getAttribute('data-alloy')) === String(want.alloy)) {
              el = all[j]; break;
            }
            if (!el) el = all[j];
          }
        }
      }
      if (!el) return;
      if (el.tagName === 'DETAILS') el.open = true;
      var sel = document.getElementById('aa-oc-f-t');
      if (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          var v = String(sel.options[i].value);
          if (v === String(want.thick) || Number(v) === Number(want.thick) ||
              v === (want.alloy + '|' + want.thick)) { sel.selectedIndex = i; break; }
        }
      }
      el.style.transition = 'box-shadow .35s ease';
      el.style.boxShadow = '0 0 0 3px #22d3ee';
      setTimeout(function () { el.style.boxShadow = ''; }, 2400);
      setTimeout(function () {
        var y = el.getBoundingClientRect().top + (window.pageYOffset || 0) - 90;
        try { window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' }); }
        catch (e2) { window.scrollTo(0, y < 0 ? 0 : y); }
      }, 60);
    } catch (x) {}
  }

  function render(list) {
    if (!list || list.ok !== true) {
      root.innerHTML = '<p class="aa-oc-empty">Offcut stock is unavailable right now. ' +
        'Please try again shortly.</p>';
      return;
    }
    var groups = list.groups || [];
    var html = '';
    if (list.syncedAt) {
      html += '<p class="aa-oc-sync">Live workshop stock \u2014 ' + esc(agoText(list.syncedAt)) +
        '. Sold as whole pieces; need it cut? Use the cut-to-size tool on the plate page.</p>';
    }
    // Size finder: enter thickness + size -> jump into the cut tool with the
    // sizes prefilled; the tool automatically uses a leftover piece when one
    // fits and is cheaper, otherwise prices from a fresh plate.
    // Only cut-capable products belong in the finder: it promises the
    // cheapest cutting route, which needs the cut-to-size tool. Offcut-only
    // products (cut: false) are excluded; if none can be cut, no finder.
    var cutProds = (CFG.products || []).filter(function (p2) { return prodCut(p2); });
    var topts = '';
    var seenFA = {}, nFA = 0;
    cutProds.forEach(function (p2) { var fa2 = prodAlloy(p2); if (!seenFA[fa2]) { seenFA[fa2] = 1; nFA++; } });
    var multiAlloy = nFA > 1;
    cutProds.slice().sort(function (a, b) { return Number(a.thick) - Number(b.thick); })
      .forEach(function (p2) {
        var a2 = prodAlloy(p2);
        // Single-alloy store (today: 5083 only): plain thickness values, exactly as before.
        // Multi-alloy: value 'alloy|thick' + alloy in the label so the right product is used.
        if (multiAlloy) topts += '<option value="' + esc(a2) + '|' + p2.thick + '">' + p2.thick + 'mm \u2014 ' + esc(a2) + '</option>';
        else topts += '<option value="' + p2.thick + '">' + p2.thick + 'mm</option>';
      });
    if (cutProds.length) html += '<div class="aa-oc-find" style="border:1.5px solid #0e7490;border-radius:10px;' +
      'padding:14px 16px;margin:0 0 16px;background:#f0fdff;">' +
      '<div style="font-weight:700;font-size:13px;color:#0f172a;margin:0 0 9px;">' +
      'Know the size you need? Enter it \u2014 we\'ll find the cheapest way to get it</div>' +
      '<div style="display:flex;flex-wrap:wrap;gap:8px 10px;align-items:flex-end;">' +
      '<label style="font-size:11px;color:#475569;">Thickness<br>' +
      '<select id="aa-oc-f-t" style="padding:8px;border:1px solid #cbd5e1;border-radius:7px;font-size:13px;">' +
      topts + '</select></label>' +
      '<label style="font-size:11px;color:#475569;">Width (mm)<br>' +
      '<input id="aa-oc-f-w" type="number" min="10" placeholder="e.g. 400" style="width:96px;padding:8px;border:1px solid #cbd5e1;border-radius:7px;font-size:13px;"></label>' +
      '<label style="font-size:11px;color:#475569;">Length (mm)<br>' +
      '<input id="aa-oc-f-l" type="number" min="10" placeholder="e.g. 200" style="width:96px;padding:8px;border:1px solid #cbd5e1;border-radius:7px;font-size:13px;"></label>' +
      '<label style="font-size:11px;color:#475569;">Qty<br>' +
      '<input id="aa-oc-f-q" type="number" min="1" value="1" style="width:60px;padding:8px;border:1px solid #cbd5e1;border-radius:7px;font-size:13px;"></label>' +
      '<button type="button" id="aa-oc-f-go" style="background:#0e7490;color:#fff;border:0;' +
      'border-radius:8px;padding:10px 18px;font-size:13px;font-weight:700;cursor:pointer;">Get my price</button>' +
      '</div>' +
      '<div style="font-size:11px;color:#64748b;margin-top:7px;">If a leftover piece fits your size, ' +
      'you automatically get it cheaper \u2014 otherwise we price it cut from a fresh plate. ' +
      'Exact price before you order.</div></div>';
    var any = false, first = true;
    var want = deepLinkTarget();
    /* Only honour the deep link if that thickness actually exists in this
       collection - otherwise fall straight back to the normal listing so a
       stale or hand-typed ?t= can never leave every accordion shut. */
    if (want) {
      var wantHit = false;
      (CFG.products || []).forEach(function (p3) {
        if (wantsThis(want, prodAlloy(p3), p3.thick)) wantHit = true;
      });
      if (!wantHit) want = null;
    }
    var gmap = {};
    // Groups are matched on alloy + thickness. Legacy worker groups (no alloy) = 5083.
    groups.forEach(function (g) { gmap[String((g.alloy || '5083')) + '|' + String(g.thickMm)] = g; });
    var prods = (CFG.products || []).slice().sort(function (a, b) { return Number(a.thick) - Number(b.thick); });
    prods.forEach(function (p) {
      var pAlloy = prodAlloy(p);
      var g = gmap[pAlloy + '|' + String(p.thick)];
      var cutUrl = p.url + '?p=' + p.url.split('/').pop();
      if (!g || !g.rows || !g.rows.length) {
        html += '<div class="aa-oc-acc" id="' + accId(pAlloy, p.thick) + '"' +
          ' data-thick="' + p.thick + '" data-alloy="' + esc(pAlloy) + '"' +
          ' style="padding:13px 16px;display:flex;align-items:center;gap:12px;">' +
          '<span class="aa-oc-sum-thick">' + p.thick + 'mm</span>' +
          '<span class="aa-oc-sum-name">no offcuts right now</span>' +
          (prodCut(p)
            ? '<a href="' + esc(cutUrl) + '" class="aa-oc-view" style="margin-left:auto;">' +
              'Cut ' + p.thick + 'mm to size from a fresh plate</a>'
            : '<span class="aa-oc-sum-meta" style="margin-left:auto;">ask us below</span>') +
          '</div>';
        return;
      }
      any = true;
      var big = g.rows[0];   // rows arrive largest-first
      var openIt = want ? wantsThis(want, pAlloy, p.thick) : first;
      html += '<details class="aa-oc-acc" id="' + accId(pAlloy, p.thick) + '"' +
        ' data-thick="' + p.thick + '" data-alloy="' + esc(pAlloy) + '"' +
        (openIt ? ' open' : '') + '>';
      first = false;
      html += '<summary class="aa-oc-sum">' +
        '<span class="aa-oc-sum-thick">' + p.thick + 'mm</span>' +
        '<span class="aa-oc-sum-name">' +
        (pAlloy === '5083' ? '5083 marine plate offcuts' : esc(pAlloy) + ' plate offcuts') + '</span>' +
        '<span class="aa-oc-sum-meta">' + g.rows.length + ' piece' + (g.rows.length === 1 ? '' : 's') +
        ' \u00b7 largest ' + big.w + ' \u00d7 ' + big.l + 'mm</span>' +
        '<span class="aa-oc-sum-chev" aria-hidden="true"></span>' +
        '</summary>';
      html += '<div class="aa-oc-panel">';
      html += '<table class="aa-oc-table"><thead><tr>' +
        '<th>Size (mm)</th><th>Area</th><th>Qty</th><th>Discount</th>' +
        '<th>Price ex GST</th><th>inc GST</th><th></th></tr></thead><tbody>';
      g.rows.forEach(function (r) {
        var key = esc(r.tab) + '|' + r.row;
        /* r40: optional per-piece Condition note from PLATES STOCKTAKE,   */
        /* shown as a small muted line under the size when present.        */
        var cnd = r.condition
          ? '<div style="font-size:10.5px;font-weight:400;' +
            'color:#94a3b8;">' + esc(r.condition) + '</div>'
          : '';
        html += '<tr data-k="' + key + '">' +
          '<td class="aa-oc-size">' + r.w + ' \u00d7 ' + r.l + cnd + '</td>' +
          '<td>' + (Number(r.areaM2) || 0).toFixed(2) + ' m\u00b2</td>' +
          '<td>' + r.qty + '</td>' +
          '<td>' + (r.discPct > 0 ? r.discPct + '% off' : '\u2014') + '</td>' +
          '<td class="aa-oc-price">' + money(r.priceExGst) + '</td>' +
          '<td>' + money(r.priceIncGst) + '</td>' +
          '<td><button type="button" class="aa-oc-add" data-thick="' + g.thickMm +
          '" data-alloy="' + esc(pAlloy) + '" data-tab="' + esc(r.tab) + '" data-row="' + r.row + '" data-w="' + r.w +
          '" data-l="' + r.l + '">Add to cart</button>' +
          (prodCut(p)
            ? '<a href="' + esc(cutUrl) +
              /* r47: carry the piece the customer actually clicked. Without this
                 "Have it cut" landed on the generic 1200x2400 plate tool with the
                 piece forgotten - and pitched a whole plate at someone who had
                 just picked a $35 offcut. oc = its size, ocref = its stocktake
                 identity so the worker can price and re-validate THAT piece. */
              '&oc=' + r.w + 'x' + r.l +
              '&ocref=' + encodeURIComponent(r.tab + ':' + r.row) +
              '" class="aa-oc-cutlink">Have it cut</a>'
            : '') +
          '</td></tr>';
      });
      html += '</tbody></table>';
      if (prodCut(p)) {
        html += '<p class="aa-oc-panel-foot">Need one of these cut to your sizes \u2014 or a size ' +
          'you can\'t see? <a href="' + esc(p.url) + '?p=' + esc(p.url.split('/').pop()) +
          '">Open the ' + g.thickMm + 'mm cut-to-size tool</a> \u2014 it automatically uses the ' +
          'cheapest option, offcut or fresh plate.</p>';
      } else {
        var label = g.thickMm + 'mm' + (pAlloy === '5083' ? '' : ' ' + pAlloy);
        html += '<p class="aa-oc-panel-foot">Need a specific size in ' + esc(label) +
          '? Ask us via the enquiry form below and we\'ll check the racks.</p>';
      }
      html += '</div></details>';
    });
    if (!any) html += '<p class="aa-oc-empty">No offcuts in stock right now \u2014 check back soon, ' +
      'stock updates through the day.</p>';
    html += '<p class="aa-oc-note">Every piece is a real one-off from our workshop \u2014 ' +
      'first come, first served. Sizes are as measured; edges may be as-cut.</p>';
    html += '<p class="aa-oc-note">Offcuts are workshop leftovers - most are ' +
      'clean, some have light surface marks or a slight bow from storage. ' +
      'They cut and machine just fine. Need blemish-free material? ' +
      'Call us or use the enquiry form for a brand-new plate.</p>';
    if (want) {
      html = '<p class="aa-oc-deep" style="background:#ecfeff;border:1px solid #a5f3fc;' +
        'border-radius:8px;padding:9px 12px;font-size:13px;color:#0f172a;margin:0 0 12px;">' +
        'Showing <strong>' + want.thick + 'mm</strong> offcuts' +
        (want.alloy ? ' \u00b7 ' + esc(want.alloy) : '') + '. ' +
        '<a href="' + esc(location.pathname) + '" style="color:#0e7490;">Show all thicknesses</a>' +
        '</p>' + html;
    }
    root.innerHTML = html;
    if (want) focusThickness(want);
  }

  function load() {
    var rates = {};
    (CFG.products || []).forEach(function (p) {
      if (p.thick > 0 && p.cents > 0 && p.vid) rates[rateKey(p)] = { unit001: p.cents / 100, plateVarId: String(p.vid) };
    });
    root.innerHTML = '<p class="aa-oc-empty">Loading live offcut stock\u2026</p>';
    post({ mode: 'offcut-list', rates: rates }).then(render);
  }

  function addOffcut(btn) {
    var thick = Number(btn.getAttribute('data-thick'));
    var alloy = btn.getAttribute('data-alloy') || '5083';
    var p = prodFor(alloy, thick);
    if (!p) return;
    var tab = btn.getAttribute('data-tab'), row = Number(btn.getAttribute('data-row'));
    var w = Number(btn.getAttribute('data-w')), l = Number(btn.getAttribute('data-l'));
    var old = btn.textContent;
    btn.disabled = true; btn.textContent = 'Checking\u2026';
    var body = { mode: 'offcut-match', thickMm: thick, pieces: [{ w: w, l: l, qty: 1 }],
      unit001: p.cents / 100, plateVarId: String(p.vid), material: p.title,
      take: { tab: tab, row: row } };
    if (alloy !== '5083') body.alloy = alloy;   // legacy 5083 bodies stay byte-identical
    post(body)
      .then(function (res) {
        if (!res || res.ok !== true || !res.lineItems || !res.lineItems.length) {
          btn.textContent = (res && res.errors && res.errors.length) ? 'Just sold \u2014 sorry' : 'Unavailable';
          setTimeout(function () { load(); }, 1800);
          return;
        }
        var items = res.lineItems.map(function (li) {
          return { id: Number(li.id), quantity: li.quantity, properties: li.properties };
        });
        try {
          var eu = location.origin + p.url + '?p=' + p.url.split('/').pop();
          if (items[0]) items[0].properties._edit = eu;
        } catch (x) {}
        return fetch('/cart/add.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () {
            if (window.AACartGuard && typeof window.AACartGuard.reconcile === 'function') {
              try { window.AACartGuard.reconcile(); } catch (e) {}
            }
            btn.textContent = 'Added \u2713';
            var td = btn.parentNode;
            if (td && !td.querySelector('.aa-oc-view')) {
              var a = document.createElement('a');
              a.href = '/cart'; a.className = 'aa-oc-view'; a.textContent = 'View cart';
              td.appendChild(a);
            }
            var tg = document.querySelector('[data-action="toggle-mini-cart"]');
            var mc = document.getElementById('mini-cart');
            if (tg && mc) {
              try {
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
                if (window.jQuery) window.jQuery(document).trigger('cart:refresh');
              } catch (e) {}
              setTimeout(function () { if (mc.getAttribute('aria-hidden') !== 'false') tg.click(); }, 300);
            }
          });
      })
      .catch(function () { btn.textContent = old; btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.aa-oc-add') : null;
    if (btn && root.contains(btn)) { e.preventDefault(); addOffcut(btn); return; }
    if (e.target && e.target.id === 'aa-oc-f-go') {
      var t = (document.getElementById('aa-oc-f-t') || {}).value;
      var w = Math.round(parseFloat((document.getElementById('aa-oc-f-w') || {}).value || '0'));
      var l = Math.round(parseFloat((document.getElementById('aa-oc-f-l') || {}).value || '0'));
      var qn = Math.max(1, parseInt((document.getElementById('aa-oc-f-q') || {}).value || '1', 10));
      // Value is plain thickness (single alloy, legacy) or 'alloy|thick' (multi-alloy).
      var fa = '5083', ft = String(t || '');
      if (ft.indexOf('|') > -1) { var fp = ft.split('|'); fa = fp[0]; ft = fp[1]; }
      var p = prodFor(fa, ft);
      if (!p) return;
      if (!(w >= 10 && l >= 10)) {
        e.target.textContent = 'Enter width + length (min 10mm)';
        setTimeout(function () { e.target.textContent = 'Get my price'; }, 2200);
        return;
      }
      location.href = p.url + '?p=' + p.url.split('/').pop() + '&cuts=' + qn + 'x' + w + 'x' + l;
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
})();
